import React from "react";
import { useTranslation } from "react-i18next";
import Statistics from "../sections/Statistics";
import chooseData from "../data/chooseData";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function AboutUs() {
  const { t } = useTranslation();
  UseScrollAnimation();

  const showData = chooseData.map((el, index) => (
    <div
      key={index}
      className="js-scroll fade-btm w-100 w-[32%] h-[250px] p-[20px] relative border-[1px] border-[#e0e0e0] flex flex-col gap-[12px] items-center justify-center text-center bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300"
    >
      <div className="text-[22px] font-bold capitalize text-[#B39359] leading-tight tracking-tight">
        {t(`${el.title}`)}
      </div>
      <p className="text-[16px] text-[#555] leading-[1.1]">{t(`${el.details}`)}</p>
    </div>
  ));

  return (
    <>
      <section className="about-landing">
        <div className="container relative h-full flex flex-col items-center justify-center">
          <div className="">
            <div className="btmAni2000 font-bold text-white text-[40px] capitalize">
              {t("Who We Are")}
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container">
          <div className="f-col flex items-center justify-between gap-[40px]">
            <div className="w-100 w-[48%]">
              <div className="js-scroll fade-left text-[35px] font-bold text-[#0B2C3D]">
                {t("Who We Are")}
              </div>
              <p className="js-scroll fade-left leading-[1.1]">
                {t("Who We Are Text")}
              </p>
            </div>
            <div className="js-scroll fade-right d-none w-100 w-[48%]">
              <img
                className="w-full h-full rounded-[8px]"
                src="https://strapi-darglobaldev.s3.me-central-1.amazonaws.com/J001267_DG_01_Rak_Al_Marjan_S07_Exterior_Hero_Final_web_520bfa333d.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="js-scroll fade-top container rounded-[8px] px-[40px] py-[20px]">
          <div className="f-col flex items-center justify-between gap-[50px]">
            <div className="js-scroll fade-left w-100 w-[60%] flex justify-end relative rounded-[8px]">
              <img
                className="w-[100%] h-[100%] rounded-[8px]"
                src={require("../../assets/projects/Tierra-6.jpg")}
                alt=""
              />
            </div>
            <div className="js-scroll fade-right w-100 w-[40%]">
              <div className="text-[35px] font-bold text-[#0B2C3D]">
                {t("Our Vision")}
              </div>
              <p className="leading-[1.1]">
                {t("Our Vision Text")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="js-scroll fade-top container rounded-[8px] px-[40px] py-[20px]">
          <div className="f-col flex items-center justify-between gap-[50px]">
            <div className="js-scroll fade-right w-100 w-[40%]">
              <div className="text-[35px] font-bold text-[#0B2C3D]">
                {t("Our Mission")}
              </div>
              <p className="leading-[1.1]">
                {t("Our Mission Text")}
              </p>
            </div>
            <div className="js-scroll fade-left w-100 w-[60%] flex justify-end relative rounded-[8px]">
              <img
                className="w-[100%] h-[100%]"
                src={require("../../assets/projects/W-5.jpg")}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <Statistics />


      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[20px]">
          <div className="js-scroll fade-top text-[35px] text-center font-bold text-[#0B2C3D]">{t("Our Values")}</div>
          <div className="f-col flex flex-wrap justify-center gap-[20px]">
            <div className="js-scroll fade-top w-100 flex flex-col gap-[10px] items-center text-center justify-center w-[30%] h-[275px] justify-evenly shadow-[0px_0px_10px_#00000021] p-5 rounded">
              <div className="font-bold text-[25px]">{t("Customer Satisfaction")}</div>
              <div className="text-[14px] leading-[1.1]">
                {t("Values one")}
              </div>
            </div>
            <div className="js-scroll fade-btm bg-[#0B2C3D] w-100 flex flex-col gap-[10px] items-center text-center justify-center w-[30%] h-[275px] justify-evenly shadow-[0px_0px_10px_#00000021] p-5 rounded">
              <div className="text-[#B39359] font-bold text-[25px]">{t("Integrity")}</div>
              <div className="text-[14px] text-white leading-[1.1]">
                {t("Values two")}
              </div>
            </div>
            <div className="js-scroll fade-top w-100 flex flex-col gap-[10px] items-center text-center justify-center w-[30%] h-[275px] justify-evenly shadow-[0px_0px_10px_#00000021] p-5 rounded">
              <div className="font-bold text-[25px]">{t("Transparency")}</div>
              <div className="text-[14px] leading-[1.1]">
                {t("Values three")}
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="relative py-[40px]">
        <div className="container">
          <div className="p-[35px] bg-[#0B2C3D] flex flex-col items-center justify-center text-center gap-[10px] rounded-[8px]">
            <div className="js-scroll fade-top text-[#B39359] font-bold text-[22px]">
              {t("Real Estate Investment")}
            </div>
            <p className="js-scroll fade-btm w-100 leading-[1.1] w-[80%] text-white text-[15px]">
              {t("Real Estate Investment Text")}
            </p>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="f-col container flex gap-[50px] justify-center items-center">
          <div className="js-scroll fade-top w-100 w-[50%] h-[500px]">
            <img
              className="w-full h-full rounded-[8px]"
              src="https://strapi-darglobaldev.s3.me-central-1.amazonaws.com/Dar_Global_AIDA_Oceana_Bird_Eye_View_2_1_e684d47436_1_b5f1d25254.png"
              alt=""
            />
          </div>
          <div className="js-scroll fade-btm w-100 w-[50%] flex flex-col gap-[30px]">
            <div className="flex flex-col gap-[20px]">
              <div className="text-[35px] font-bold text-[#0B2C3D] capitalize">
                {t("Our Team")}
              </div>
              <p className="leading-[1.1]">
                {t("Our Team Text")}
              </p>
            </div>
            <div className="flex flex-col gap-[10px]">
              <div className="flex items-center gap-[7px]">
                <img
                  className="w-[18px] h-[18px]"
                  src={require("../../assets/image/yes.svg").default}
                  alt=""
                />
                <div>{t("Real Estate Professionals")}</div>
              </div>
              <div className="flex items-center gap-[7px]">
                <img
                  className="w-[18px] h-[18px]"
                  src={require("../../assets/image/yes.svg").default}
                  alt=""
                />
                <div>{t("Tech Experts")}</div>
              </div>
              <div className="flex items-center gap-[7px]">
                <img
                  className="w-[18px] h-[18px]"
                  src={require("../../assets/image/yes.svg").default}
                  alt=""
                />
                <div>{t("Customer Service Representatives")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[20px] justify-center items-center">
          <div className="js-scroll fade-top text-[35px] font-bold text-[#0B2C3D] capitalize">
            {t("Why Choose Us")}
          </div>
          <div className="flex justify-center gap-[15px] flex-wrap">
            {showData}
          </div>
        </div>
      </section>


    </>
  );
}
